"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageTypeEnum = void 0;
// 页面类型
var pageTypeEnum = exports.pageTypeEnum = [{
  label: '首页',
  value: 1
}, {
  label: '商品详情页',
  value: 2
}, {
  label: '商品分类页',
  value: 3
}, {
  label: '装修页',
  value: 4
}, {
  label: '积分商城',
  value: 5
}, {
  label: '权益商品',
  value: 6
}, {
  label: '一键加油页',
  value: 7
}, {
  label: '直饮水首页',
  value: 8
}, {
  label: '戎州驿充首页',
  value: 9
}, {
  label: '荣E停列表首页',
  value: 10
}, {
  label: '团购列表页',
  value: 11
}, {
  label: '团购店铺详情页',
  value: 12
}, {
  label: '团购商品详情页',
  value: 13
}, {
  label: '酒店列表页',
  value: 14
}, {
  label: '酒店店铺详情页',
  value: 15
}, {
  label: '酒店商品详情页',
  value: 16
}, {
  label: '外卖列表页',
  value: 17
}, {
  label: '外卖店铺详情页',
  value: 18
}, {
  label: '外卖商品详情页',
  value: 19
}];